// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-wrapper.gant-table .ant-table.ant-table-middle .ant-table-cell {
  padding: 4px;
  font-size: 10px;
  color: #000000;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,
.ant-table-wrapper.gant-table .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th {
  border-inline-end: 1px solid #A6B0B6;
  border-bottom-color: #A6B0B6;
}
.ant-table-wrapper.gant-table .ant-table-thead > tr > th {
  text-align: center;
}
.ant-table-wrapper.gant-table .ant-table-thead > tr > th:has(> .hovered) {
  background: #C6E1FF;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .ant-table-cell:has(.empty) {
  background: #F3F6F8;
  color: #384146;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .ant-table-cell:has(.completed) {
  background: #DBF4E3;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .ant-table-cell:has(.in-work) {
  background: #FFE49D;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .ant-table-cell:has(.not-started) {
  background: #FFFFFF;
  color: #85929A;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .gant-table__cell.overdue:not(.not-started) {
  color: #DE1E04;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .gant-table__cell.advance:not(.not-started) {
  color: #0075FF;
}
.ant-table-wrapper.gant-table .ant-table.ant-table-middle .ant-table-cell:has(.current) {
  background: #FFE49D;
}

section.gant {
  width: 100%;
}

.gant-table__day.weekend {
  color: #1A76E2;
}
.gant-table__cell:not(.empty) {
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gant-table__name-icon {
  cursor: pointer;
}
.gant-table__name-root {
  font-weight: 600;
}
.gant-table__arrow {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  transform: translateY(-0.15em);
}

.state-blocks-container {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.state-item {
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: nowrap;
}

.state-block {
  gap: 10px;
  padding: 0 10px;
  border: 1px solid #D5DCDF;
}

.gant-filter {
  padding: 10px;
  border-radius: 4px;
  background: #FFFFFF;
}
.gant-filter .ant-select-single.ant-select-lg .ant-select-selector,
.gant-filter .ant-select-multiple.ant-select-lg,
.gant-filter .ant-picker-large .ant-picker-input > input {
  font-size: 14px;
}
.gant-filter .ant-picker {
  height: 40px;
}
.gant-filter__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #181A1C;
}
.gant-filter__button {
  font-size: 14px;
  box-shadow: unset;
}`, "",{"version":3,"sources":["webpack://./src/assets/gant.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,eAAA;EACA,cAAA;AAAR;AAGI;;EAEI,oCAAA;EACA,4BAAA;AADR;AAII;EACI,kBAAA;AAFR;AAIQ;EACI,mBAAA;AAFZ;AAMI;EACI,mBAAA;EACA,cAAA;AAJR;AAOI;EACI,mBAAA;AALR;AAQI;EACI,mBAAA;AANR;AASI;EACI,mBAAA;EACA,cAAA;AAPR;AAUI;EACI,cAAA;AARR;AAWI;EACI,cAAA;AATR;AAYI;EACI,mBAAA;AAVR;;AAcA;EACI,WAAA;AAXJ;;AAgBQ;EACI,cAAA;AAbZ;AAiBI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAfR;AAkBI;EACI,eAAA;AAhBR;AAmBI;EACI,gBAAA;AAjBR;AAoBI;EACI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;AAlBR;;AAsBA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8BAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,SAAA;EACA,eAAA;EACA,yBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AAnBJ;AAqBI;;;EAGI,eAAA;AAnBR;AAsBI;EACI,YAAA;AApBR;AAuBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AArBR;AAwBI;EACI,eAAA;EACA,iBAAA;AAtBR","sourcesContent":[".ant-table-wrapper.gant-table {\n    .ant-table.ant-table-middle .ant-table-cell {\n        padding: 4px;\n        font-size: 10px;\n        color: #000000;\n    }\n\n    .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,\n    .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th {\n        border-inline-end: 1px solid #A6B0B6;\n        border-bottom-color: #A6B0B6;\n    }\n\n    .ant-table-thead > tr > th {\n        text-align: center;\n\n        &:has(> .hovered) {\n            background: #C6E1FF;\n        }\n    }\n\n    .ant-table.ant-table-middle .ant-table-cell:has(.empty) {\n        background: #F3F6F8;\n        color: #384146;\n    }\n\n    .ant-table.ant-table-middle .ant-table-cell:has(.completed) {\n        background: #DBF4E3;\n    }\n\n    .ant-table.ant-table-middle .ant-table-cell:has(.in-work) {\n        background: #FFE49D;\n    }\n\n    .ant-table.ant-table-middle .ant-table-cell:has(.not-started) {\n        background: #FFFFFF;\n        color: #85929A;\n    }\n\n    .ant-table.ant-table-middle .gant-table__cell.overdue:not(.not-started) {\n        color: #DE1E04;\n    }\n\n    .ant-table.ant-table-middle .gant-table__cell.advance:not(.not-started) {\n        color: #0075FF;\n    }\n\n    .ant-table.ant-table-middle .ant-table-cell:has(.current) {\n        background: #FFE49D;\n    }\n}\n\nsection.gant {\n    width: 100%;\n}\n\n.gant-table {\n    &__day {\n        &.weekend {\n            color: #1A76E2;\n        }\n    }\n\n    &__cell:not(.empty) {\n        text-align: center;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    &__name-icon {\n        cursor: pointer;\n    }\n\n    &__name-root {\n        font-weight: 600;\n    }\n\n    &__arrow {\n        display: inline-flex;\n        align-items: center;\n        vertical-align: middle;\n        transform: translateY(-0.15em);\n    }\n}\n\n.state-blocks-container {\n    display: flex;\n    align-items: center;\n    background: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 40px;\n}\n\n.state-item {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: center;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    white-space: nowrap;\n}\n\n.state-block {\n    gap: 10px;\n    padding: 0 10px;\n    border: 1px solid #D5DCDF;\n}\n\n.gant-filter {\n    padding: 10px;\n    border-radius: 4px;\n    background: #FFFFFF;\n\n    .ant-select-single.ant-select-lg .ant-select-selector,\n    .ant-select-multiple.ant-select-lg,\n    .ant-picker-large .ant-picker-input > input {\n        font-size: 14px;\n    }\n\n    .ant-picker {\n        height: 40px;\n    }\n\n    &__title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 16px;\n        text-align: left;\n        color: #181A1C;\n    }\n\n    &__button {\n        font-size: 14px;\n        box-shadow: unset;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
